import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Catalog from "@/components/Catalog";
import TechSection from "@/components/TechSection";
import Manifesto from "@/components/Manifesto";

export default function Home() {
  return (
    <>
      <Hero />
      <Marquee />
      <Catalog />
      <TechSection />
      <Manifesto />
    </>
  );
}
